export const transformRequestGenerateReturnLabel = ({ resourceId, includeRejectedItems }) => {
  return {
    resourceId,
    payload: {
      include_rejected_items: includeRejectedItems,
      discard_previous_labels: false,
    },
  }
}
